<div class="labels-settings">
  <app-ui-page-header
    title="Labels de conversas"
    subtitle="Defina as labels dispon&iacute;veis para classificar conversas."
    density="compact"
  />

  <form appUiPanelCard class="labels-settings__create" (submit)="$event.preventDefault(); create()">
    <div class="labels-settings__create-row">
      <input
        appInput
        type="text"
        placeholder="Nome da label"
        [value]="newName()"
        (input)="setName($any($event.target).value)"
      />
      <button appButton variant="primary" size="sm" type="submit" [disabled]="saving() || newName().trim().length === 0">
        Criar
      </button>
    </div>
    <app-label-color-picker [value]="newColor()" (valueChange)="setColor($event)" />
    <textarea
      appTextarea
      rows="2"
      placeholder="Descri&ccedil;&atilde;o (opcional, m&aacute;x. 500 caracteres)"
      maxlength="500"
      [value]="newDescription()"
      (input)="setDescription($any($event.target).value)"
    ></textarea>
  </form>

  <section appUiFilterBar aria-label="Filtrar labels">
    <label appUiFilterSearch>
      <ng-icon class="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-muted" name="heroMagnifyingGlass" size="14" aria-hidden="true" />
      <input
        appInput
        leadingIcon
        type="search"
        placeholder="Buscar por nome"
        [value]="search()"
        (input)="setSearch($any($event.target).value)"
      />
    </label>
    <div appUiFilterActions>
      <button appButton variant="ghost" size="sm" type="button" (click)="toggleIncludeArchived()">
        {{ includeArchived() ? 'Ocultar arquivadas' : 'Mostrar arquivadas' }}
      </button>
    </div>
  </section>

  @if (visibleLabels().length > 0) {
    <ul appUiRecordList>
      @for (label of visibleLabels(); track label.id) {
        <li appUiRecordRow [interactive]="false" [class.labels-settings__item--archived]="label.isArchived">
          <span appUiRecordRowMain>
            <span appUiRecordRowBody>
              <span appUiRecordRowTitle class="labels-settings__title-line">
                <span class="labels-settings__swatch" [style.background]="label.color"></span>
                {{ label.name }}
              </span>
              @if (label.description) {
                <span appUiRecordRowDescription>{{ label.description }}</span>
              }
            </span>
          </span>

          <span appUiRecordRowMeta>
            @if ((label.assignmentsCount ?? 0) > 0) {
              <span appBadge tone="neutral" size="xs" [attr.title]="(label.assignmentsCount ?? 0) + ' conversas usam esta label'">
                {{ label.assignmentsCount }} em uso
              </span>
            }
            @if (label.isArchived) {
              <span appBadge tone="neutral" size="xs">Arquivada</span>
            }
          </span>

          <span appUiRecordRowActions>
            <button
              appButton
              variant="ghost"
              size="sm"
              type="button"
              [disabled]="busyLabelId() === label.id"
              (click)="toggleArchive(label)"
            >
              <ng-icon [name]="label.isArchived ? 'heroArchiveBoxArrowDown' : 'heroArchiveBox'" size="14" aria-hidden="true" />
              {{ label.isArchived ? 'Restaurar' : 'Arquivar' }}
            </button>
            <button
              appButton
              variant="ghost"
              size="sm"
              type="button"
              [disabled]="busyLabelId() === label.id || (label.assignmentsCount ?? 0) > 0"
              [attr.title]="(label.assignmentsCount ?? 0) > 0 ? 'Em uso - arquive em vez de excluir' : 'Excluir definitivamente'"
              (click)="remove(label)"
            >
              <ng-icon name="heroTrash" size="14" aria-hidden="true" />
              Excluir
            </button>
          </span>
        </li>
      }
    </ul>
  } @else {
    <app-ui-empty-state
      title="Nenhuma label encontrada"
      description="Crie uma label ou ajuste a busca para encontrar labels arquivadas."
    />
  }
</div>
